import { TableColumnsButton } from '~shared/ui/table-columns-button';
import { TableSortButton } from '~shared/ui/table-sort-button';

import { SORT_OPTIONS } from '../lib/columns';
import type { UseSummaryTableReturn } from '../model/use-summary-table';

type Props = {
  table: UseSummaryTableReturn;
};

export function SummaryTableControls({ table }: Props) {
  return (
    <div className="flex shrink-0 gap-2">
      <TableSortButton
        options={SORT_OPTIONS}
        value={table.sortValue}
        onApply={table.onSortingChange}
      />
      <TableColumnsButton
        options={table.columnOptions}
        value={table.visibleColumns}
        onApply={table.setVisibleColumns}
      />
    </div>
  );
}
